import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { OptionTextModule } from '../../options/text/option-text.module';
import { QuestionTextComponent } from './question-text.component';

@NgModule({
  imports: [QuestionModule, OptionTextModule],
  declarations: [QuestionTextComponent],
  exports: [QuestionTextComponent]
})
export class QuestionTextModule {}
